<template>
  <div>
    <div class="card-body">
          <h2>Branches List</h2>
          <v-select v-model="selectedBranch" :options="branches" label="TITLE" placeholder="Select Branch" @input="addBranch"></v-select>
          <h2>Selected Branches</h2>
          <table class="branch-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Branch</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(branch, ind) in selectedBranches" :key="branch.BA_ID">
                <td>{{ ind + 1 }}</td>
                <td>{{ branch.TITLE }}</td>
                <td>
                  <button type="button" @click="removeBranch(branch)" class="btn btn-danger"><i class="fas fa-trash"></i></button>
                </td>
              </tr>
              <tr v-if="!selectedBranches.length">
                <td colspan="4">No branches selected</td>
              </tr>
            </tbody>
          </table>
        </div>
    <div class="card-footer">
      <button type="button" v-on:click="submitForm" class="btn btn-success float-right mr-1">Submit</button>
    </div>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      clientid: Number,
    },
    data() {
      return {
        branches: [],
        selectedBranches: [],
        selectedBranch: null,
      };
    },
    created() {
      this.pageLoad();
    },
    methods: {
      pageLoad() {
        var vm = this;
        axios.get("/api/UICApi/pageLoadBranchlist?ID=" + this.clientid)
          .then(function (res) {
            vm.branches = res.data.list.map(item => ({
              BA_ID: item.BA_ID,
              BA_BRANCH: item.BA_BRANCH,
              BP_ID: item.BP_ID,
              BA_ISACTIVE: item.BA_ISACTIVE || 'Y',
              TITLE: item.TITLE
            }));
            if (res.data.selectBranches.length > 0) {
              vm.selectedBranches = res.data.selectBranches;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },
      addBranch() {
        if (this.selectedBranch && !this.selectedBranches.some(b => b.BA_ID === this.selectedBranch.BA_ID)) {
          this.selectedBranches.push({ ...this.selectedBranch, BA_ISACTIVE: 'Y' });
          this.selectedBranch = null;
        }
      },
      removeBranch(branch) {
        const index = this.selectedBranches.indexOf(branch);
        if (index !== -1) {
          this.selectedBranches.splice(index, 1);
        }
      },
      submitForm() {
        var vm = this;
        startReq();
        axios.post('/api/UICApi/SaveBranchList', {
          Branches: vm.selectedBranches,
        })
          .then(response => {
            endReq();
            if (response.data.status) {
              toastr.success(response.data.msg);
            } else {
              toastr.error(response.data.msg);
            }
          })
          .catch(error => {
            endReq();
            vm.error = 'Error saving BranchAssignment';
            console.log(error);
          });
      },
    }
  };
</script>

<style>
  .container {
    display: flex;
    width: 100%;
    max-width: 1500px;
    margin: 0 auto;
    padding: 20px;
    background-color: #f9f9f9;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  }

  .left-panel, .right-panel {
    width: 50%;
    padding: 20px;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    margin-right: 20px;
  }

  .right-panel {
    margin-right: 0;
  }

  h2 {
    font-size: 1.5rem;
    color: #333;
    margin-bottom: 15px;
    font-weight: 600;
    border-bottom: 2px solid #4CAF50;
    padding-bottom: 5px;
  }

  .branch-table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 15px;
  }

    .branch-table th, .branch-table td {
      padding: 10px;
      border: 1px solid #e0e0e0;
      text-align: left;
    }

    .branch-table th {
      background-color: #f5f5f5;
      font-weight: 600;
    }

  .status-dropdown {
    padding: 5px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 0.9rem;
    background-color: #fff;
  }

    .status-dropdown:focus {
      outline: none;
      border-color: #4CAF50;
    }

  .btn-danger {
    padding: 5px 10px;
  }

  @media (max-width: 768px) {
    .container {
      flex-direction: column;
    }

    .left-panel, .right-panel {
      width: 100%;
      margin-right: 0;
      margin-bottom: 20px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ims/BranchAssignment.vue